var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignThisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 27C19 27.5523 18.5523 28 18 28C17.4477 28 17 27.5523 17 27H19ZM18 6V5H19V6H18ZM5 6L4.13076 6.49438C3.9547 6.18484 3.95655 5.80502 4.1356 5.4972C4.31465 5.18938 4.64389 5 5 5V6ZM5 19.5V20.5C4.64577 20.5 4.31798 20.3126 4.13826 20.0074C3.95854 19.7021 3.95372 19.3246 4.12559 19.0148L5 19.5ZM8.79167 12.6667L9.66091 12.1723C9.83339 12.4756 9.83535 12.8468 9.66607 13.1519L8.79167 12.6667ZM19 7.94444C19 8.49673 18.5523 8.94444 18 8.94444C17.4477 8.94444 17 8.49673 17 7.94444H19ZM17 17.5556C17 17.0033 17.4477 16.5556 18 16.5556C18.5523 16.5556 19 17.0033 19 17.5556H17ZM18 7H5V5H18V7ZM17 27V19.5H19V27H17ZM5 18.5H18V20.5H5V18.5ZM5.86924 5.50562L9.66091 12.1723L7.92242 13.161L4.13076 6.49438L5.86924 5.50562ZM9.66607 13.1519L5.87441 19.9852L4.12559 19.0148L7.91726 12.1815L9.66607 13.1519ZM17 7.94444V6H19V7.94444H17ZM17 19.5V17.5556H19V19.5H17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17L27 13L23 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H27",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignThisIcon);
export default __webpack_public_path__ + "static/media/assignThisIcon.9a16b8cf860abaf229373d06e61e1050.svg";
export { ForwardRef as ReactComponent };